import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/field/Button';
import getTapPaymentUserPhone from 'components/payment/tap/getTapPaymentUserPhone';

import useAlert from 'hooks/useAlert';

import axios from 'services/axios';
import fetchRemainingAmount from 'services/common/fetchRemainingAmount';
import { PAYMENT } from 'services/consts';

import { setLoading } from 'stores/layoutSlice';

import AppLogger from 'utils/AppLogger';
import { PAYMENT_GATEWAY_TYPE } from 'utils/constants';

import { faCheck } from '@fortawesome/pro-solid-svg-icons';

let popup;
const BuyLabelWithCreditCard = ({ onResult, paymentDetails, label, disabledTooltip, disabled = false, isLoading }) => {
	const dispatch = useDispatch();
	const { loading } = useSelector((state) => state?.layout);
	const { paymentGatewayType } = useSelector((state) => state?.user.localization);
	const { showError } = useAlert();
	const [paymentResultChecking, setPaymentResultChecking] = useState(false);
	const isTapPayment = [PAYMENT_GATEWAY_TYPE.TAP_PAYMENT, PAYMENT_GATEWAY_TYPE.TAP_PAYMENT_UAE].includes(
		paymentGatewayType
	);

	const checkPayment = async (id) => {
		dispatch(setLoading(true));
		axios
			.post(PAYMENT.CHECK_PAYMENT, { ID: id })
			.then(async (res) => {
				const { data, status } = res;
				if (status === 200 && data) {
					if (data.status !== 'pending') {
						await fetchRemainingAmount();
						onResult?.(data.status === 'paid');
						dispatch(setLoading(false));
						if (data.status !== 'paid') {
							showError({
								header: 'error',
								message: data?.description
							});
						}
					} else {
						setTimeout(() => {
							checkPayment(id);
						}, 3 * 1000);
					}
				} else {
					showError();
					AppLogger.error(res);
					dispatch(setLoading(false));
				}
			})
			.catch((error) => {
				showError();
				AppLogger.error(error);
				dispatch(setLoading(false));
			});
	};

	useEffect(() => {
		if (!isTapPayment) {
			return;
		}
		const handleMessage = (message) => {
			if (message.data.event !== 'checkPaymentResult') return;

			setPaymentResultChecking(true);
			popup?.close();

			setTimeout(() => {
				checkPayment(message.data?.paymentID);
			}, 5 * 1000); // wait for 5 second to make sure the webhook is triggered
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);

	useEffect(() => {
		if (!isTapPayment) {
			return;
		}
		if (!loading || paymentResultChecking) return;
		const interval = setInterval(() => {
			if (popup?.closed) {
				dispatch(setLoading(false));
			}
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	}, [loading, paymentResultChecking]);

	const completePaymentTapPayment = async () => {
		dispatch(setLoading(true));
		popup = window.open('/payment-redirect-en.html', '_blank');
		const userPhone = getTapPaymentUserPhone();

		await axios
			.post(PAYMENT.MAKE_CHARGE, {
				subtotal: paymentDetails?.amount,
				countryCode: userPhone.countryCode,
				phone: userPhone.phone,
				ignoreMinimumChargeAmount: true,
				saveCard: false,
				clientCardID: Number(paymentDetails?.id)
			})
			.then(async (res) => {
				const { data, status } = res;
				if (status === 200 && data) {
					const { transactionUrl } = data;
					if (transactionUrl) {
						popup.location.href = transactionUrl;
					} else {
						popup.close();
						dispatch(setLoading(false));
					}
				} else {
					popup.close();
					showError();
					AppLogger.error(res);
					dispatch(setLoading(false));
				}
			})
			.catch((error) => {
				popup.close();
				if (error.response?.data.code === 'error.P002') {
					showError({
						message: 'errorMsg.invalidPromoCode'
					});
				} else if (error.response?.data.code === 'error.P014') {
					showError({
						message: 'errorMsg.tapPaymentConnectionTimedOut'
					});
				} else if (error.response?.data.code === 'error.P027') {
					showError({
						message: 'error.P027'
					});
				} else {
					showError();
					AppLogger.error(error);
				}
				dispatch(setLoading(false));
			});
	};

	const completePaymentPayTR = async () => {
		dispatch(setLoading(true));
		popup = window.open('/payment-redirect-tr.html', '_blank');

		try {
			const response = await axios.post(PAYMENT.MAKE_CHARGE_PAYTR, {
				subtotal: paymentDetails?.amount,
				cardID: paymentDetails?.id,
				ignoreMinimumChargeAmount: true
			});

			const { data, status } = response;

			if (status === 200 && data.success) {
				checkPayment(data.paymentID);
				popup.document.write(data.response);
				popup.document?.body?.onload?.();
				if (!data.response) {
					popup.close();
				}
			} else {
				popup.close();
				showError();
				AppLogger.error(data);
				dispatch(setLoading(false));
			}
		} catch (error) {
			popup.close();
			dispatch(setLoading(false));
			if (error.response?.data.code === 'error.P002') {
				showError({
					message: 'errorMsg.invalidPromoCode'
				});
			} else {
				showError();
				AppLogger.error(error);
			}
		}
	};

	return (
		<Button
			icon={faCheck}
			label={label || 'buyLabel'}
			onClick={
				paymentGatewayType === PAYMENT_GATEWAY_TYPE.PAYTR ? completePaymentPayTR : completePaymentTapPayment
			}
			disabled={disabled}
			disabledTooltip={disabledTooltip}
			loading={isLoading}
		/>
	);
};

export default BuyLabelWithCreditCard;
